import React, { useState, useEffect } from "react";
import { Modal, Form, Tabs, Tab } from "react-bootstrap";
import PathFinderAgent from "../AiVoice/PathFinderAgent";

const AIModal = (props) => {
  return (
    <>
      <Modal
        id="join-modal"
      className="custom-modal1 custom-modal2 custom-modal3"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // style={{
        //   minWidth: "90vw",
        // }}
      >
        <Modal.Header>
          <div>
            <h3>PathFinder Agent</h3>
            <i className="fa-solid fa-xmark" onClick={props.onHide}></i>
          </div>
        </Modal.Header>

        <Modal.Body
          style={{
            minHeight: "60vh",
            maxHeight: "80vh",
            overflowY: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <PathFinderAgent 
          popup={true} 
          userToken={props.userToken}
          onCloseOpenModal={props.onCloseOpenModal}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AIModal;
